<template>
  <base-modal modal-content-class="game_modals rg">
    <div class="content">
      <h1>{{ getTranslations.home_modals_resume_game_welcome_back }} {{ userDetails.username }}!</h1>

      <img :src="userDetails.avatar" class="avatar_home" alt="">

      <p>{{ getTranslations.home_modals_game_in_progress_wait }}</p>

      <base-button container-class="resume" @button:click="$emit('resume:game')">
        {{ getTranslations.home_modals_resume_game_resume_button || getTranslations.home_play_game }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import BaseModal from '../../common/modal/BaseModal'
import BaseButton from '../../common/button/BaseButton'

export default {
  name: 'ResumeGameModal',
  components: {
    BaseModal,
    BaseButton,
  },
  emits: ['resume:game'],
  computed: {
    ...mapState('common', [
      'userDetails'
    ]),
    ...mapGetters('i18n', [
      'getTranslations'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ResumeGameModal.vue